/* GENERATED with v0.0.117 of https://github.beeone.at/George/ibo
 * FROM v1.0.0 of "Export Center"
 * CHANGES WILL BE LOST, DO NOT MAKE MANUAL CHANGES
 */
/* istanbul ignore file */
/* eslint-disable */
import type { CreateExportSetDefinitionDto } from '../models/CreateExportSetDefinitionDto';
import type { CreateExportSetDefinitionSuccessResponse } from '../models/CreateExportSetDefinitionSuccessResponse';
import type { GenerateHistoricalSnapshotsRequest } from '../models/GenerateHistoricalSnapshotsRequest';
import type { GetExportSetDefinitionsSuccessResponse } from '../models/GetExportSetDefinitionsSuccessResponse';
import type { ImportExportSetDefinitionsRequestDto } from '../models/ImportExportSetDefinitionsRequestDto';
import type { ImportExportSetDefinitionSuccessResponse } from '../models/ImportExportSetDefinitionSuccessResponse';

import { clientOptionsFactory } from '../clientOptions';
import { apiClientRequest as __request } from '@api-client/base';
import type { ClientOptions } from '@api-client/base';

export class ManageExportSetDefinitionsService {

    /**
     * Import a batch of Export Set definitions.
     *
     * @returns ImportExportSetDefinitionSuccessResponse The success response containing information on the imported Export Set definitions.
     *
     * @throws ApiError
     */
    public static postExportSets({
        requestBody,
    }: {
        /**
         * Import a batch of Export Set definitions.
         *
         */
        requestBody?: ImportExportSetDefinitionsRequestDto
    },
    clientOptionsOverride: { skipParseJSON: true } & Partial<ClientOptions>): Promise<Response>;
    public static postExportSets({
        requestBody,
    }: {
        /**
         * Import a batch of Export Set definitions.
         *
         */
        requestBody?: ImportExportSetDefinitionsRequestDto
    },
    clientOptionsOverride?: Partial<ClientOptions>): Promise<ImportExportSetDefinitionSuccessResponse>;
    public static postExportSets({
        requestBody
    }: {
        /**
         * Import a batch of Export Set definitions.
         *
         */
        requestBody?: ImportExportSetDefinitionsRequestDto,
    },
    clientOptionsOverride: Partial<ClientOptions> = {}
) {
    return __request(
        {...clientOptionsFactory.get()(), ...clientOptionsOverride},
        {
            method: 'POST',
            url: '/export-sets',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The requested input data could not be used, probably has an invalid format.
                `,
            },
        });
    }

    /**
     * Enqueue historical snapshot generation for the given Export Set IDs.
     * This explicit variant keeps the caller-supplied Export Set selection.
     * Historical generation is performed only for imported Export Set definitions, identified by a present `hostId`.
     * Export Set definitions already marked as having completed historical generation are skipped.
     * A missing completion flag is treated the same as `false`.
     *
     * @returns any Historical snapshot generation requests were enqueued successfully.
     * During processing, non-imported or already completed Export Set definitions are ignored.
     *
     * @throws ApiError
     */
    public static putExportSetsGenerateHistoricalSnapshots({
        requestBody,
    }: {
        /**
         * Request historical snapshots to be generated for the given Export Set IDs.
         *
         */
        requestBody?: GenerateHistoricalSnapshotsRequest
    },
    clientOptionsOverride: { skipParseJSON: true } & Partial<ClientOptions>): Promise<Response>;
    public static putExportSetsGenerateHistoricalSnapshots({
        requestBody,
    }: {
        /**
         * Request historical snapshots to be generated for the given Export Set IDs.
         *
         */
        requestBody?: GenerateHistoricalSnapshotsRequest
    },
    clientOptionsOverride?: Partial<ClientOptions>): Promise<any>;
    public static putExportSetsGenerateHistoricalSnapshots({
        requestBody
    }: {
        /**
         * Request historical snapshots to be generated for the given Export Set IDs.
         *
         */
        requestBody?: GenerateHistoricalSnapshotsRequest,
    },
    clientOptionsOverride: Partial<ClientOptions> = {}
) {
    return __request(
        {...clientOptionsFactory.get()(), ...clientOptionsOverride},
        {
            method: 'PUT',
            url: '/export-sets/generate-historical-snapshots',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The requested input data could not be used, probably has an invalid format.
                `,
            },
        });
    }

    /**
     * Enqueue historical snapshot generation for all eligible imported Export Set definitions.
     * Eligible definitions have a present `hostId` and `historicalSnapshotsGenerated` equal to `null` or `false`.
     * Definitions already marked as completed are skipped automatically.
     *
     * @returns any Historical snapshot generation requests were enqueued successfully for all eligible imported Export Set definitions.
     *
     * @throws ApiError
     */
    public static postExportSetsGenerateHistoricalSnapshots(
        clientOptionsOverride: { skipParseJSON: true } & Partial<ClientOptions>): Promise<Response>;
        public static postExportSetsGenerateHistoricalSnapshots(
            clientOptionsOverride?: Partial<ClientOptions>): Promise<any>;
            public static postExportSetsGenerateHistoricalSnapshots(
                clientOptionsOverride: Partial<ClientOptions> = {}
            ) {
                return __request(
                    {...clientOptionsFactory.get()(), ...clientOptionsOverride},
                    {
                        method: 'POST',
                        url: '/export-sets/generate-historical-snapshots',
                        errors: {
                            400: `The requested input data could not be used, probably has an invalid format.
                            `,
                        },
                    });
                }

                /**
                 * Request a new Export Set definition to be created.
                 * The Export Set definition is used to generate export set files.
                 *
                 * @returns CreateExportSetDefinitionSuccessResponse The success response containing information on the created Export Set definition.
                 *
                 * @throws ApiError
                 */
                public static postPublicExportSets({
                    requestBody,
                }: {
                    /**
                     * Create a new export set definition.
                     *
                     */
                    requestBody?: CreateExportSetDefinitionDto
                },
                clientOptionsOverride: { skipParseJSON: true } & Partial<ClientOptions>): Promise<Response>;
                public static postPublicExportSets({
                    requestBody,
                }: {
                    /**
                     * Create a new export set definition.
                     *
                     */
                    requestBody?: CreateExportSetDefinitionDto
                },
                clientOptionsOverride?: Partial<ClientOptions>): Promise<CreateExportSetDefinitionSuccessResponse>;
                public static postPublicExportSets({
                    requestBody
                }: {
                    /**
                     * Create a new export set definition.
                     *
                     */
                    requestBody?: CreateExportSetDefinitionDto,
                },
                clientOptionsOverride: Partial<ClientOptions> = {}
            ) {
                return __request(
                    {...clientOptionsFactory.get()(), ...clientOptionsOverride},
                    {
                        method: 'POST',
                        url: '/public/export-sets',
                        body: requestBody,
                        mediaType: 'application/json',
                        errors: {
                            400: `The requested input data could not be used, probably has an invalid format.
                            `,
                        },
                    });
                }

                /**
                 * Fetch all Export Set definitions stored in Export Center.
                 *
                 * @returns GetExportSetDefinitionsSuccessResponse The success response containing the list of Export Set definitions associated to the user's license.
                 *
                 * @throws ApiError
                 */
                public static getPublicExportSets(
                    clientOptionsOverride: { skipParseJSON: true } & Partial<ClientOptions>): Promise<Response>;
                    public static getPublicExportSets(
                        clientOptionsOverride?: Partial<ClientOptions>): Promise<GetExportSetDefinitionsSuccessResponse>;
                        public static getPublicExportSets(
                            clientOptionsOverride: Partial<ClientOptions> = {}
                        ) {
                            return __request(
                                {...clientOptionsFactory.get()(), ...clientOptionsOverride},
                                {
                                    method: 'GET',
                                    url: '/public/export-sets',
                                });
                            }

                            /**
                             * Retrieve a specific Export Set definition by its ID.
                             *
                             * @returns CreateExportSetDefinitionSuccessResponse The success response containing information on the created Export Set definition.
                             *
                             * @throws ApiError
                             */
                            public static getPublicExportSetsById({
                                id,
                            }: {
                                /**
                                 * The ID of the Export Set definition to retrieve.
                                 */
                                id: string
                            },
                            clientOptionsOverride: { skipParseJSON: true } & Partial<ClientOptions>): Promise<Response>;
                            public static getPublicExportSetsById({
                                id,
                            }: {
                                /**
                                 * The ID of the Export Set definition to retrieve.
                                 */
                                id: string
                            },
                            clientOptionsOverride?: Partial<ClientOptions>): Promise<CreateExportSetDefinitionSuccessResponse>;
                            public static getPublicExportSetsById({
                                id
                            }: {
                                /**
                                 * The ID of the Export Set definition to retrieve.
                                 */
                                id: string,
                            },
                            clientOptionsOverride: Partial<ClientOptions> = {}
                        ) {
                            return __request(
                                {...clientOptionsFactory.get()(), ...clientOptionsOverride},
                                {
                                    method: 'GET',
                                    url: '/public/export-sets/{id}',
                                    path: {
                                        'id': id,
                                    },
                                    errors: {
                                        400: `The requested input data could not be used, probably has an invalid format.
                                        `,
                                        403: `User does not have permissions to download one or more of the requested files.
                                        `,
                                        404: `The requested export set definition could not be found.
                                        `,
                                    },
                                });
                            }

                            /**
                             * Update an existing Export Set definition by its ID.
                             * The Export Set definition is used to generate export set files.
                             *
                             * @returns CreateExportSetDefinitionSuccessResponse The success response containing information on the created Export Set definition.
                             *
                             * @throws ApiError
                             */
                            public static putPublicExportSets({
                                id,
                                requestBody,
                            }: {
                                /**
                                 * The ID of the Export Set definition to update.
                                 */
                                id: string,
                                /**
                                 * Create a new export set definition.
                                 *
                                 */
                                requestBody?: CreateExportSetDefinitionDto
                            },
                            clientOptionsOverride: { skipParseJSON: true } & Partial<ClientOptions>): Promise<Response>;
                            public static putPublicExportSets({
                                id,
                                requestBody,
                            }: {
                                /**
                                 * The ID of the Export Set definition to update.
                                 */
                                id: string,
                                /**
                                 * Create a new export set definition.
                                 *
                                 */
                                requestBody?: CreateExportSetDefinitionDto
                            },
                            clientOptionsOverride?: Partial<ClientOptions>): Promise<CreateExportSetDefinitionSuccessResponse>;
                            public static putPublicExportSets({
                                id,
                                requestBody
                            }: {
                                /**
                                 * The ID of the Export Set definition to update.
                                 */
                                id: string,
                                /**
                                 * Create a new export set definition.
                                 *
                                 */
                                requestBody?: CreateExportSetDefinitionDto,
                            },
                            clientOptionsOverride: Partial<ClientOptions> = {}
                        ) {
                            return __request(
                                {...clientOptionsFactory.get()(), ...clientOptionsOverride},
                                {
                                    method: 'PUT',
                                    url: '/public/export-sets/{id}',
                                    path: {
                                        'id': id,
                                    },
                                    body: requestBody,
                                    mediaType: 'application/json',
                                    errors: {
                                        400: `The requested input data could not be used, probably has an invalid format.
                                        `,
                                        403: `User does not have permissions to download one or more of the requested files.
                                        `,
                                        404: `The requested export set definition could not be found.
                                        `,
                                    },
                                });
                            }

                            /**
                             * Delete an Export Set definition by its ID.
                             *
                             * @returns any Export Set definition deleted successfully.
                             * @throws ApiError
                             */
                            public static deletePublicExportSets({
                                id,
                            }: {
                                /**
                                 * The ID of the Export Set definition to delete.
                                 */
                                id: string
                            },
                            clientOptionsOverride: { skipParseJSON: true } & Partial<ClientOptions>): Promise<Response>;
                            public static deletePublicExportSets({
                                id,
                            }: {
                                /**
                                 * The ID of the Export Set definition to delete.
                                 */
                                id: string
                            },
                            clientOptionsOverride?: Partial<ClientOptions>): Promise<any>;
                            public static deletePublicExportSets({
                                id
                            }: {
                                /**
                                 * The ID of the Export Set definition to delete.
                                 */
                                id: string,
                            },
                            clientOptionsOverride: Partial<ClientOptions> = {}
                        ) {
                            return __request(
                                {...clientOptionsFactory.get()(), ...clientOptionsOverride},
                                {
                                    method: 'DELETE',
                                    url: '/public/export-sets/{id}',
                                    path: {
                                        'id': id,
                                    },
                                    errors: {
                                        400: `The requested input data could not be used, probably has an invalid format.
                                        `,
                                        403: `User does not have permissions to download one or more of the requested files.
                                        `,
                                    },
                                });
                            }

                        }
